(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchCustomerDeleteController',PatchCustomerDeleteController);

    PatchCustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchCustomer'];

    function PatchCustomerDeleteController($uibModalInstance, entity, PatchCustomer) {
        var vm = this;
        vm.patchCustomer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchCustomer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
